module.exports = __webpack_public_path__ + "static/media/18ECA32.adfe25a9.jpg";